import { IModelApp } from "@itwin/core-frontend";
import { XAndY } from "@itwin/core-geometry";
import { AbstractToolbarProps } from "@itwin/appui-abstract";

export interface PopupToolbarProvider {
  delayPopup: number;
  delayClose: number;
  toolbarProps: AbstractToolbarProps;
  itemExecuted(id: string, item: string): void;
}

export class PopupToolbarManager {
  private static _provider?: PopupToolbarProvider;
  private static _timer: any;
  private static _isTimer: boolean;
  private static _isInside: boolean;
  private static _id: string;
  private static _x: number;
  private static _y: number;

  public static showToolbar = (provider: PopupToolbarProvider, id: string, x: number, y: number): void => {
    if (this._provider) {
      this.close();
    }

    this._provider = provider;
    this._id = id;
    this._x = x;
    this._y = y;

    this._timer = setTimeout(
      () => this.show(),
      this._provider.delayPopup
    );

    this._isInside = true;
  }

  private static show = (): boolean => {
    const prov = this._provider;

    if (this._isInside && this._provider) {
      const admin = IModelApp.uiAdmin;
      const tbProp = this._provider?.toolbarProps;
      const tbLoc = this.toolbarLocation();
      if (
        !admin.showToolbar(
          tbProp!,
          tbLoc,
          admin.createXAndY(0, 0),
          this._itemExecuted,
          this._cancel
        )
      )
        return false;
    }

    return true;
  }

  public static closeToolbar = (): void => {
    if (!this._provider) return;

    setTimeout(
      () => this.closeDelayed(),
      this._provider.delayClose
    ); // Cursor not in view or over hotspot, check again
    
    this._isTimer = true;
    this._isInside = false;
  }

  private static closeDelayed = () => {
    if (this._isTimer === true) {
      this.close();
    }
  }

  private static close = () => {
    if (this._provider) IModelApp.uiAdmin.hideToolbar();
    if (this._timer) clearTimeout(this._timer);

    this._provider = undefined;
    this._timer = undefined;
    this._isTimer = false;
    this._isInside = false;
  }

  public static _itemExecuted = (item: any) => {
    this._provider?.itemExecuted(
      this._id,
      item.id
    );
    this.close();
  };

  public static _cancel = () => {
    this.close();
  };

  public static toolbarLocation = (): XAndY => {
    return IModelApp.uiAdmin.createXAndY(
      this._x,
      this._y
    );
  }
}
